"use strict";
/*
* Created on 28.11.2018
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationRequest_1 = require("../../core/model/ValidationRequest");

var ForecastSimulationUpdateDTO_1 = require("../../forecast-simulation/model/ForecastSimulationUpdateDTO");

var SupplierAgreementValidatorHints_1 = require("../../supply/model/SupplierAgreementValidatorHints");

var WindowItemValidationRequest_1 = require("../validation/WindowItemValidationRequest");

var WindowActionControlLevel;

(function (WindowActionControlLevel) {
  WindowActionControlLevel[WindowActionControlLevel["STANDARD"] = 0] = "STANDARD"; // This level disables some window action checks
  // Action is then quicker, but there is chance to create inconsistent data

  WindowActionControlLevel[WindowActionControlLevel["QUICK"] = 1] = "QUICK";
})(WindowActionControlLevel = exports.WindowActionControlLevel || (exports.WindowActionControlLevel = {}));
/**
 * @author MSu
 */


var WindowActionContext =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowActionContext, _DomainObject_1$Domai);

  // tslint:disable-next-line
  function WindowActionContext(windowId, actionType, sessionId) {
    var _this;

    var simActions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : immutable_1.List.of();
    var windowItemValidationRequest = arguments.length > 4 ? arguments[4] : undefined;
    var supplierAgreementValidationRequest = arguments.length > 5 ? arguments[5] : undefined;
    var controlLevel = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, WindowActionContext);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowActionContext).call(this));
    _this.windowId = windowId;
    _this.actionType = actionType;
    _this.sessionId = sessionId;
    _this.simActions = simActions;
    _this.windowItemValidationRequest = windowItemValidationRequest;
    _this.supplierAgreementValidationRequest = supplierAgreementValidationRequest;
    _this.controlLevel = controlLevel;

    if (!_this.controlLevel) {
      _this.controlLevel = WindowActionControlLevel.STANDARD;
    }

    return _this;
  }

  _createClass(WindowActionContext, [{
    key: "resetSessionId",
    value: function resetSessionId(sessionId) {
      return this.copy('sessionId', sessionId ? sessionId : null);
    }
  }]);

  return WindowActionContext;
}(DomainObject_1.DomainObject);

exports.WindowActionContext = WindowActionContext;

WindowActionContext.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowActionContext.name);
  return {
    windowId: builder.str('windowId'),
    actionType: builder.str('actionType'),
    sessionId: builder.opt(builder.str('sessionId')),
    simActions: builder.listOf(builder.obj('simActions', ForecastSimulationUpdateDTO_1.ForecastSimulationUpdateDTO.schema, function (mat) {
      return ForecastSimulationUpdateDTO_1.ForecastSimulationUpdateDTO.fromDataDict(mat);
    })),
    windowItemValidationRequest: builder.opt(builder.objc('windowItemValidationRequest', WindowItemValidationRequest_1.WindowItemValidationRequest.schema, WindowItemValidationRequest_1.WindowItemValidationRequest)),
    supplierAgreementValidationRequest: builder.opt(builder.objc('supplierAgreementValidationRequest', ValidationRequest_1.ValidationRequest.getSchema(SupplierAgreementValidatorHints_1.SupplierAgreementValidatorHints), ValidationRequest_1.ValidationRequest)),
    controlLevel: builder.opt(builder.senum('controlLevel', WindowActionControlLevel, ''))
  };
}();